import { fetchApi } from 'api/fetchApi'
import { definitions } from 'api/generated/language'

export const fetchLocaleApi = () =>
  fetchApi<definitions['Language']>('/languages/current')
